export function createReducer(initState, actionReducerMap) {
    return (state = initState, action) => {
        const reducer = actionReducerMap[action.type];
        return reducer ? reducer(state, action) : state;
    };
}
export function createAction(type) {
    return (payload, meta, error) => {
        return {
            type,
            payload,
            meta,
            error
        };
    };
}
